import { useState } from "react";
import { CogIcon } from "@olivahealth/oli-ui";
import UserRole from "@olivahealth/graphql-server/src/domain/value-objects/UserRole";
import { useUserData } from "../../../services/contexts/UserDataContext";
import ResetUser from "./ResetUser";
import ModifySession from "./ModifySession";

export default function AdminConsole(): JSX.Element | null {
  const [isOpen, setIsOpen] = useState(false);
  const { data: userData } = useUserData();

  const isAdmin = userData?.role?.includes(UserRole.ADMIN);

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed top-4 right-4 z-50 p-2 rounded-full bg-white shadow-md hover:bg-gray-50"
        aria-label="Open Admin Console"
      >
        <CogIcon size={24} />
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50">
          <div
            className={`
              fixed top-0 right-0 w-1/2 h-full 
              bg-white shadow-xl 
              transform transition-transform duration-300 ease-in-out
              flex flex-col
            `}
          >
            <div className="flex justify-between items-center p-6 border-b">
              <h2 className="text-xl font-bold">Admin Console</h2>
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            <div className="p-6 flex-1 overflow-y-auto space-y-6">
              <ResetUser />
              <hr className="my-6" />
              <ModifySession />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
